import { Component, Input } from '@angular/core';

@Component({
  selector: 'sm-icon',
  template: `<svg [attr.width]="width" [attr.height]="height" aria-hidden="true" focusable="false"><use [attr.href]="'assets/images/icons-sprite.svg#icon-' + name"></use></svg>`,
  styles: [`:host { display: inline-flex; align-items: center; justify-content: center; }`]
})
export class IconComponent {
  @Input() name: string;
  @Input() width: number = 20;
  @Input() height: number = 20;
}
